import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationEnd, Router, RouterEvent, RouterStateSnapshot } from '@angular/router';

import { logger } from 'src/lib/utils/logging';
import { Observable } from 'rxjs';
import { filter, map, shareReplay, tap } from 'rxjs/operators';

import { RouterState, RouterStateData } from './RouterState';



@Injectable({providedIn: 'root'})
export class RouterStateService {
  readonly state$: Observable<RouterState>;

  constructor(private router: Router) {
    this.state$ = router.events.pipe(
      // filter((event: RouterEvent) => event instanceof NavigationEnd),
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map((event: NavigationEnd) => this.serialize(event, router.routerState.snapshot)),
      tap((state: RouterState) => logger.log('[ RouterState ]', state)),
      shareReplay(1)
    );
  }

  private serialize(event: RouterEvent, snapshot: RouterStateSnapshot): RouterState {
    const { root, url } = snapshot;
    const { queryParams } = root;

    return new RouterState({
      data: this.flatten(root, 'data'),
      initial: event.id === 1,
      params: this.flatten(root, 'params'),
      path: url.split('?')[0],
      queryParams,
      url
    });
  }

  private flatten(snapshot: ActivatedRouteSnapshot, propName: string, propValues?: any): RouterStateData {
    if (!propValues) propValues = snapshot[propName];
    if (!(Array.isArray(snapshot.children) && snapshot.children.length)) return propValues;

    return snapshot.children.reduce((values, child) => {
      values = Object.assign({}, values, child[propName]);
      return this.flatten(child, propName, values);
    }, propValues);
  }
}
